import React from "react"

import { RoomFormTabType } from "features/room-management/types/RoomFormTabType"

import { EditRoomOverlay } from "./EditRoomOverlay"
import { useEditRoomOverlayModel } from "./hooks/useEditRoomOverlayModel"

export interface EditRoomOverlayPayload {
  projectID: string
  roomID: string
  defaultTab?: RoomFormTabType
}

export interface EditRoomOverlayConnectorProps {
  payload: EditRoomOverlayPayload
}

export const EditRoomOverlayConnector = React.memo(
  (props: EditRoomOverlayConnectorProps) => {
    return <EditRoomOverlay autoFocus {...useEditRoomOverlayModel(props)} />
  }
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    EDIT_ROOM_OVERLAY: EditRoomOverlayPayload
  }
}
